import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12C/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12C/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12C/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12C/4.jpg';

// import p5 from 'assests/Photos/ClassAssembly/2024/12A/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12A/6.jpg';
// import p7 from 'assests/Photos/ClassAssembly/2024/12A/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Box from '@mui/material/Box';
import CoScholacticSidebar2025 from '../CoScholacticSidebar2025';
import Archive_2022 from '../CurricularClass52023/Archive_2022';


const FieldTrip72025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  
 
const p1 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/FieldTrip7/1.webp`;
const p2 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/FieldTrip7/2.webp`;
const p3 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/FieldTrip7/3.webp`;
const p4 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/FieldTrip7/4.webp`;
const p5 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/FieldTrip7/5.webp`;
const p6 = `${config.base_image_url_2025}/home/events-activities/association/Co-Scholastic/FieldTrip7/6.webp`;





  

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
}


  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
     Visit to Suggee Resort
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: 7     Date: 30 October 2025

        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Tell me and I forget, teach me and I may remember, involve me and I learn. – Benjamin Franklin”

<br/>
        </Typography> */}

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
       National Public School, Yeshwanthpur, organised a field trip for the students of Class 7 to Suggee Resort, providing a refreshing break from their regular routine. The day began with students being introduced to a series of exciting activities, setting a tone of enthusiasm and curiosity for the experiences ahead.
       <br></br>
       Throughout the day, the students participated in a range of adventurous outdoor activities, including Land Zorbing, Zip Lining, Wall Climbing, Archery, Foosball and the High Rope Course. Their enthusiasm and active involvement in every challenge reflected a strong spirit of teamwork and determination.
       <br></br>
       The visit to Suggee Resort proved to be more than just a recreational outing. It was a valuable experience that emphasised the importance of physical fitness, well-being and experiential learning. By blending fun with education, the trip left students with cherished memories and a deeper appreciation for health and outdoor activity.
       <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Adventure unleashed – Class 7 takes on Suggee Resort!”

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 250 : 350}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <CoScholacticSidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive_2022/>
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default FieldTrip72025;